import { Box, CircularProgress, TableCell, TableRow } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"
import type { ReactElement } from "react"

interface TableLoadingRowProps {
  columns: ColumnDef<any, any>[]
  className?: string
}

export const TableLoadingRow = ({ columns, className }: TableLoadingRowProps): ReactElement => {
  return (
    <TableRow className={className}>
      <TableCell colSpan={columns.length} align='center' className='py-8'>
        <Box className='flex flex-col items-center gap-2'>
          <CircularProgress size={48} />
        </Box>
      </TableCell>
    </TableRow>
  )
}
